import { MarcaCompania } from "@/componentes/impresos/MarcaCompania"
import { Ondas } from "@/componentes/impresos/Ondas"
import { cuerpoEnLinea, dato, filete, titular, versal } from "./estilo"
import { MEDIDAS } from "./medidas"
import type { DatosPestana } from "./tipos"

/** La pestañita: dice qué contiene la carpeta, y se lee con la carpeta parada. */
export function PestanaCarpeta({ datos }: { datos: DatosPestana }) {
  const { ancho, alto } = MEDIDAS.PESTANA
  const util = datos.siglas || datos.periodo ? 38 : 54

  return (
    <article
      className="pieza-impresa"
      style={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        gap: "2.4mm",
        width: `${ancho}mm`,
        height: `${alto}mm`,
        padding: "0 3mm 0 7.4mm",
        fontFamily: "var(--font-rotulo-texto)",
      }}
      aria-label={`Pestaña: ${datos.contenido || "sin contenido"}`}
    >
      <Ondas pieza="pestana" style={{ left: 0, top: 0, width: "5.3mm", height: "100%" }} />
      <MarcaCompania compania={datos.compania} alto={9.5} descriptor={false} />
      <div style={filete({ width: "0.26mm", height: "8.5mm" })} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {datos.departamento ? (
          <p
            style={versal(cuerpoEnLinea(datos.departamento, util, 2.5, 1.7), {
              letterSpacing: "0.16em",
              whiteSpace: "nowrap",
            })}
          >
            {datos.departamento}
          </p>
        ) : null}
        <p
          style={titular(cuerpoEnLinea(datos.contenido, util, 4, 2.4), {
            whiteSpace: "nowrap",
            marginTop: "0.5mm",
          })}
        >
          {datos.contenido}
        </p>
      </div>
      {datos.siglas || datos.periodo ? (
        <div style={{ textAlign: "right", flexShrink: 0 }}>
          {datos.siglas ? <p style={titular(3.3)}>{datos.siglas}</p> : null}
          {datos.periodo ? (
            <p
              className="tabular"
              style={dato(2.8, {
                fontWeight: 600,
                color: "var(--impreso-vino)",
                marginTop: "0.5mm",
              })}
            >
              {datos.periodo}
            </p>
          ) : null}
        </div>
      ) : null}
    </article>
  )
}
